import React, { Component } from "react";
import { GetText } from '../config/helper';
import { Nav } from 'react-bootstrap';
import { FaCaretRight } from "react-icons/fa6";

const arrMenu = [
	{link: "", nameEn: "Dashboard", nameId: "Dashboard", diff: 0, diffLabel: "", level: 1 },
	
	{link: "", nameEn: "Library", nameId: "Library", diff: 0, diffLabel: "", level: 1 },
	{link: "ctcategory/library", nameEn: "Category", nameId: "Kategori", diff: 0, diffLabel: "", level: 2 },
	{link: "ctlibrary", nameEn: "Library List", nameId: "Daftar Library", diff: 0, diffLabel: "", level: 2 },

	{link: "", nameEn: "Workshop", nameId: "Workshop", diff: 0, diffLabel: "", level: 1 },
	{link: "ctcategory/course", nameEn: "Category", nameId: "Kategori", diff: 0, diffLabel: "", level: 2 },
	{link: "ctcourse", nameEn: "Workshop List", nameId: "Daftar Workshop", diff: 0, diffLabel: "", level: 2 },
	{link: "cttutor", nameEn: "Trainers List", nameId: "Daftar Pelatih", diff: 0, diffLabel: "", level: 2 },
	{link: "ctfaqcourse", nameEn: "FAQ in Workshop ", nameId: "FAQ di Workshop", diff: 0, diffLabel: "", level: 2 },

	{link: "ctusertraining", nameEn: "Users", nameId: "Pengguna", diff: 0, diffLabel: "", level: 1 },
	{link: "ctcompanytraining", nameEn: "Companies", nameId: "Perusahaan", diff: 0, diffLabel: "", level: 1 },
	{link: "ctfeedback", nameEn: "Feedback", nameId: "Umpan Balik", diff: 0, diffLabel: "", level: 1 },
	{link: "ctvoucher", nameEn: "Voucher", nameId: "Voucher", diff: 0, diffLabel: "", level: 1 },
	{link: "ctcontactus", nameEn: "Contact Us", nameId: "Hubungi Kami", diff: 0, diffLabel: "", level: 1 },
	{link: "ctfaq", nameEn: "FAQ in Novaio", nameId: "FAQ di Novaio", diff: 0, diffLabel: "", level: 1 },
	{link: "ctbanner", nameEn: "Banner Management", nameId: "Pengaturan Banner", diff: 0, diffLabel: "", level: 1 },
	{link: "ctsstories", nameEn: "Success Stories", nameId: "Kisah Sukses", diff: 1, diffLabel: "Gemini Academy", level: 1 },
	
	{link: "", nameEn: "Prompt Collection", nameId: "Koleksi Prompting", diff: 0, diffLabel: "", level: 1 },
	{link: "ctcategory/prompt", nameEn: "Category", nameId: "Kategori", diff: 0, diffLabel: "", level: 2 },
	{link: "ctprompt-list", nameEn: "Prompt List", nameId: "Daftar prompting", diff: 0, diffLabel: "", level: 2 },

	{link: "", nameEn: "Discussion Room", nameId: "Ruang Diskusi", diff: 0, diffLabel: "", level: 1 },
	{link: "ctcategory/discussion", nameEn: "Category", nameId: "Kategori", diff: 0, diffLabel: "", level: 2 },
	{link: "ctdiscussion-list", nameEn: "Topic List", nameId: "Daftar Topik", diff: 0, diffLabel: "", level: 2 },
];

export default class MenuLeftCMS extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activetab: "",
		}
	}
	componentDidMount() {
		var content = this.props.value;
		console.log(content);
		this.setState({
			activetab: content.tabkey
		});
	}

	openLink(destination) {
		window.location.href='/c/'+destination;
	}
	
	render() {
		
		return (
			<div>
				<div className="mt-4"><h3 className="mb-4 mx-3">{GetText() ? "Pengaturan" : "Settings"}</h3></div>
				<div>
					<Nav variant="pills" className="flex-column pills-scroll mt-5 mb-5 mb-md-0" defaultActiveKey={this.state.activetab}>
					{ 
						arrMenu.map((contentMenu, i) => {
							return(
								<Nav.Item key={i}>
									{contentMenu.diff > 0 && <hr /> } 
									{contentMenu.diffLabel !== "" && <div className="mb-3 ms-2">
										<h5>{contentMenu.diffLabel}</h5>
									</div>}
									{contentMenu.link !== ""? 
										<div className={`${
											(contentMenu.level === 2) ? "ms-4 " : ""
											}`}>
										<Nav.Link 
											eventKey={contentMenu.link} 
											onClick={() => this.openLink(contentMenu.link)}
											active={(this.state.activetab === contentMenu.link)? "true" : ""}
										>
											<div>{contentMenu.level === 2 && <FaCaretRight /> } {GetText() ? contentMenu.nameId : contentMenu.nameEn}</div>
										</Nav.Link>
										</div>
									: 	<div className={`${
												(contentMenu.level === 2) ? "ms-4" : ""
											}`}><Nav.Link><div>{contentMenu.level === 2 && <FaCaretRight /> } {GetText() ? contentMenu.nameId : contentMenu.nameEn}</div></Nav.Link></div>
									}
								</Nav.Item>
							)
						})
					}
						
						
					</Nav>
				</div>
				
			</div>
		);
	}
}
